<template>
  <div class="container">
    <div class="sign-container">
      <div class="sign-frame">
        <div class="sign-side blue">
          <img :src="this.baseURL + '/mascots/main.svg'" alt="DS Mascot" />
          <h1 v-html="$t('Signup.welcome')"></h1>

          <h3 v-html="$t('make_planning')"></h3>

          <div class="quote">
            <p v-html="$t('Signin.quote')"></p>
          </div>
        </div>

        <div class="sign-side">
          <div class="form">
            <h2>{{ $t("Signup.create_account") }}</h2>
            <span class="subheader">
              {{ $t("Signup.has_account") }}
              <router-link :to="`/sign-in${search}`">{{ $t("Signup.sign_in") }}</router-link>
            </span>

            <div class="field mt-5">
              <label class="required-label" for="email">{{ $t("Signup.email") }}</label>
              <InputText id="email" placeholder="name@company.com" type="email" v-model="email" />
            </div>

            <Button
              :disabled="!this.validateEmail(email) || busy"
              class="btn-submit"
              @click="signUp"
              :label="$t('Signup.sign_up')"
            />

            <div v-if="!jpLocale">
              <div class="or-divider mt-2 mb-1">Or</div>

              <div class="button se-button" @click="startSportsEngineAuth">
                Sign up with
                <img src="/se_logo_full.png" alt="Sports Engine" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    link: [{ rel: "canonical", href: "https://app.cactusware.com/sign-up" }],
  },
  data() {
    return {
      busy: false,
      email: "",
      search: window.location.search,
    };
  },
  methods: {
    signUp() {
      this.busy = true;
      const user = {
        email: this.email.toLowerCase(),
        first: this.email.split("@")[0],
        password: (Math.random() + 1).toString(36).substring(2),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timezone_offset: this.$moment(new Date()).format("Z"),
        locale: this.$i18n.locale,
        referer: window.location.href || "direct",
      };

      api
        .createTempUser(user)
        .then(response => {
          this.$store
            .dispatch("signIn", {
              email: user.email,
              password: user.password,
            })
            .then(() => {
              localStorage.setItem("user_id", response.data.id);
              localStorage.setItem("user_email", response.data.email);
              localStorage.setItem("locale", user.locale);
              this.makeToast("success", this.$t("Toast.sign_up_success"));
              this.trackEvent("Signed Up", { user: response.data });
              this.proceed(this.getURLParam("return") || "/wizard");
              this.busy = false;
            });
        })
        .catch(error => {
          console.error(error);
          this.makeToast("error", "Something went wrong...");
          alert(this.$t("Signup.alert.already_have_account"));
          if (this.search) {
            this.goRouter("/sign-in" + this.search + "&email=" + this.email);
          } else {
            this.goRouter("/sign-in?email=" + this.email);
          }
        });
    },
  },
  mounted() {
    window.analytics.page();

    if (window.location.href.includes("localhost")) {
      this.email = "email" + new Date().getTime() + "@test.com";
    }
  },
};
</script>
